import { render } from "./StaffAugmentation.vue?vue&type=template&id=c475d532&scoped=true"
import script from "./StaffAugmentation.vue?vue&type=script&lang=js"
export * from "./StaffAugmentation.vue?vue&type=script&lang=js"

import "./StaffAugmentation.vue?vue&type=style&index=0&id=c475d532&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c475d532"]])

export default __exports__